(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'projectDrillDown',
            [
                'CHROME',
                ProjectDrillDownFactory
            ]
        );

    // Factory Method
    function ProjectDrillDownFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.TOOLBAR.DRILL_DOWN + CHROME.POSTFIX
        };

    }
})();



